<template>
  <ModalDialog
    ref="dialog"
    title="NCR Accounts"
    icon="fa-repeat"
    
    :showSubmit="false"
    :scrollable="true"
    @closed="onClosed">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <div v-if="!loading">
      <ContentTitle>NCR Generated Invoices</ContentTitle>
      <InvoiceDataTable
        :openNewTab="true"
        :displaySearch="false"
        :displayPageCount="false"
        :displayExportTools="false"
        :displayFilters="false"
        :displayDateFilter="false"
        :displayFooterNote="false"
        :filterOrderId="orderId">
      </InvoiceDataTable>
      <div class="mt-4"> </div>
      <ContentTitle>NCR Generated Credit Notes</ContentTitle>
      <CreditNoteDataTable
        :openNewTab="true"
        :displaySearch="false"
        :displayPageCount="false"
        :displayExportTools="false"
        :displayFilters="false"
        :displayDateFilter="false"
        :displayFooterNote="false"
        :filterOrderId="orderId">
      </CreditNoteDataTable>


    </div>
  </ModalDialog>
</template>

<script>
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import InvoiceDataTable from '@/modules/accounts/components/invoiceDataTable'
import CreditNoteDataTable from '@/modules/accounts/components/creditNoteDataTable'

export default {
  name: 'OrderNCRAccountsDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    InvoiceDataTable,
    CreditNoteDataTable
  },
  props: {
    orderId: Number    
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      linkedInvoices: [],
      linkedCreditNotes: []
    }
  },
  mounted() {
    this.requestData()    
  },
  computed: {
    
  },
  methods: {
    show(params) {
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    requestData() {
      this.loadingError = ''

      this.loading = true
      Promise.all([
        this.$apiService.accountsService.getInvoiceFilteredList({ filter: { orderId: this.orderId } }),
        this.$apiService.accountsService.getCreditNoteFilteredList({ filter: { orderId: this.orderId } })
      ])
      .then(results => {
        this.linkedInvoices = results[0].data
        this.linkedCreditNotes = results[1].data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })

    }
  }
}
</script>